module.exports = {"id":"dp3_3l1q5","text":"Copyright and licences","instructions":"Which type of content is commonly free to use without payment?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l1q5-a1","text":"Public domain material","score":1.8},{"id":"dp3_3l1q5-a2","text":"Recent news articles","score":0},{"id":"dp3_3l1q5-a3","text":"Paid stock images","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l1q5.json
// module id = 1159
// module chunks = 41